import React from "react";
import PropTypes from "prop-types";
import RtrImage from "../shared/rtr-image";

class FitNotes extends React.Component {
  static propTypes = {
    product: PropTypes.object.isRequired,
  };

  render() {
    var product = this.props.product,
      fitNotes = product?.fitNotes ?? "",
      assetPrefix = "//cdn.rtrcdn.com/sites/default/files/imgs/size_fit/",
      lengthChart;

    if (this.props.hasLengths) {
      lengthChart = (
        <div>
          <h3>Length Chart</h3>

          <p>
            <RtrImage alt="Length Chart" src={assetPrefix + "length_2x.png"} width="533" />
          </p>

          <p className="subtitle">Dresses may not be offered in all of the above lengths.</p>
        </div>
      );
    }

    return (
      <div>
        <h3>Size &amp; Fit Notes</h3>

        <div dangerouslySetInnerHTML={{ __html: fitNotes }} />

        <h3>Size Chart</h3>

        <p>
          <RtrImage alt="Size Chart" src={assetPrefix + "missy_2x.png"} width="533" />
        </p>

        <h3>Plus Size Size Chart</h3>

        <p>
          <RtrImage alt="Plus Size Size Chart" src={assetPrefix + "plus.png"} width="663" />
        </p>

        {lengthChart}
      </div>
    );
  }
}

export default FitNotes;
